const R = /[\p{Lu}]/u, p = /[\p{Ll}]/u, E = /^[\p{Lu}](?![\p{Lu}])/gu, I = /([\p{Alpha}\p{N}_]|$)/u, A = /[_.\- ]+/, U = new RegExp("^" + A.source), L = new RegExp(A.source + I.source, "gu"), h = new RegExp("\\d+" + I.source, "gu"), v = (e, r, a, t) => {
  let o = !1, s = !1, f = !1, C = !1;
  for (let l = 0; l < e.length; l++) {
    const c = e[l];
    C = l > 2 ? e[l - 3] === "-" : !0, o && R.test(c) ? (e = e.slice(0, l) + "-" + e.slice(l), o = !1, f = s, s = !0, l++) : s && f && p.test(c) && (!C || t) ? (e = e.slice(0, l - 1) + "-" + e.slice(l - 1), f = s, s = !1, o = !0) : (o = r(c) === c && a(c) !== c, f = s, s = a(c) === c && r(c) !== c);
  }
  return e;
}, _ = (e, r) => (E.lastIndex = 0, e.replaceAll(E, (a) => r(a))), d = (e, r) => (L.lastIndex = 0, h.lastIndex = 0, e.replaceAll(h, (a, t, o) => ["_", "-"].includes(e.charAt(o + a.length)) ? a : r(a)).replaceAll(L, (a, t) => r(t)));
function x(e, r) {
  if (!(typeof e == "string" || Array.isArray(e)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (r = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...r
  }, Array.isArray(e) ? e = e.map((s) => s.trim()).filter((s) => s.length).join("-") : e = e.trim(), e.length === 0)
    return "";
  const a = r.locale === !1 ? (s) => s.toLowerCase() : (s) => s.toLocaleLowerCase(r.locale), t = r.locale === !1 ? (s) => s.toUpperCase() : (s) => s.toLocaleUpperCase(r.locale);
  return e.length === 1 ? A.test(e) ? "" : r.pascalCase ? t(e) : a(e) : (e !== a(e) && (e = v(e, a, t, r.preserveConsecutiveUppercase)), e = e.replace(U, ""), e = r.preserveConsecutiveUppercase ? _(e, a) : a(e), r.pascalCase && (e = t(e.charAt(0)) + e.slice(1)), d(e, t));
}
export {
  x as default
};
